
import inputNumber from "./inputNumber.vue"
import unitPromotionList from "./unitPromotionList.vue"
import { isChecked, soldOut, getMax, fen2Yuan, getNumber, getSmallNumber, showMessage } from "./js/common.js"
import { trackSelectItem, handleChangeCartNumber } from "@/utils/track"
export default {
  name: "WareCard",
  components: {
    inputNumber,
    unitPromotionList
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    venderId: {
      type: Number,
      default: 0
    },
    unRange: {
      type: Boolean,
      default: false
    },
    slaveStore: {
      type: Boolean,
      default: false
    },
    isDeliveryOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ware() {
      const wareList = this.item.wareList || []
      return wareList[0] || {}
    },
    proTag() {
      const promotionList = this.item.promotionList || []
      const promotionInfo = promotionList[0] || {}
      return (promotionInfo.promotionDisplay && promotionInfo.promotionDisplay.proTag) || ""
    },
    bestOfferPromotionDisplayList() {
      return this.ware.bestOfferPromotionDisplayList || []
    }
  },
  methods: {
    isChecked,
    soldOut,
    getMax,
    fen2Yuan,
    getNumber,
    getSmallNumber,
    // 切换商品勾选
    toggleWareSelect(item) {
      if (this.unRange) return

      this.$emit("toggleWareSelect", {
        items: [item]
      })
    },
    // 删除单个商品
    handleWareDelete(item) {
      if (this.unRange) return
      handleChangeCartNumber(0, item.beforeCount, item)
      this.$emit("handleWareDelete", item)
    },
    handleOverMaximum() {
      showMessage(this.$t("cart.maximumStockTips"))
    },
    handleNumChange(value, item) {
      if (this.unRange) return

      this.$emit("handleNumChange", value, item)
    },
    findSimilar(skuId) {
      window.open(`${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${skuId}`)
    },
    toProductDetail(item) {
      if (this.slaveStore) return
      this.trackSelectItem(item, () => {
        this.$navigation.push({
          path: `${this.MAIN_PATH}/p/${encodeURIComponent(item.wareName)}/i/${item.skuId}.html`
        })
      })
    },
    addMore(item) {
      this.$emit("addMore", item, "unit", this.ware.skuId)
    },
    trackSelectItem
  }
}
